import service from '@/utils/axios-v2'
import recaptcha from '@/utils/recaptcha'

export function getLoadBoard(params) {
  return service({
    url: '/fleet/load/boards',
    method: 'get',
    params
  })
}

export function addLoadBoard(data) {
  return service({
    url: '/fleet/load/boards',
    method: 'put',
    data
  })
}

export function deactivateLoadBoard(data) {
  return service({
    url: '/fleet/load/boards',
    method: 'delete',
    data
  })
}

export function addLoadBoardSources(source) {
  return service({
    url: '/fleet/load/boards/sources',
    method: 'put',
    data: { source }
  })
}

export async function getLoadList(type, data) {
  let token = ''
  try {
    token = await recaptcha('getTripartiteLoads')
  } catch {
    token = ''
  }
  return service({
    url: '/fleet/load/boards/loads',
    params: { type }, // 1是load 2是favorite
    data,
    method: 'post',
    headers: {
      'recaptcha-token': token
    }
  })
}

// 收藏/取消收藏
export function favoriteLoad(data) {
  return service({
    url: '/fleet/load/boards/favorite',
    method: 'put',
    data
  })
}